import {
  GET_EXCEL_DOWNLOAD_CHALLAN,
  GET_EXCEL_DOWNLOAD_CHALLAN_FAIL,
  GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL,
  GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL,
  GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS,
  GET_EXCEL_DOWNLOAD_LEAD,
  GET_EXCEL_DOWNLOAD_LEAD_FAIL,
  GET_EXCEL_DOWNLOAD_LEAD_SUCCESS,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL,
  GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS,
  GET_EXCEL_DOWNLOAD_SALE,
  GET_EXCEL_DOWNLOAD_SALE_FAIL,
  GET_EXCEL_DOWNLOAD_SALE_SUCCESS,
  GET_EXCEL_DOWNLOAD_VEHICLE,
  GET_EXCEL_DOWNLOAD_VEHICLE_FAIL,
  GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS,
} from "./actionTypes"

// ExCel Download - This line cannot be edited or removed
export const getExcelDownloadSale = (
  page,
  totalItemLimit,
  SearchText,
  clientId,
  vehicleId,
  sortByDate,
  branchId
) => ({
  type: GET_EXCEL_DOWNLOAD_SALE,
  payload: {
    page,
    totalItemLimit,
    SearchText,
    clientId,
    vehicleId,
    sortByDate,
    branchId,
  },
})

export const getExcelDownloadSaleSuccess = excelDownloadSale => ({
  type: GET_EXCEL_DOWNLOAD_SALE_SUCCESS,
  payload: excelDownloadSale,
})

export const getExcelDownloadSaleFail = error => ({
  type: GET_EXCEL_DOWNLOAD_SALE_FAIL,
  payload: error,
})

export const getExcelDownloadVehicle = (
  pageVehicle,
  totalItemLimit,
  vehicleSearchText,
  brandId,
  modelId,
  varientId,
  oilTypeValue,
  ownerShipStatusValue,
  sort,
  dateBySort,
  branchId
) => ({
  type: GET_EXCEL_DOWNLOAD_VEHICLE,
  payload: {
    pageVehicle,
    totalItemLimit,
    vehicleSearchText,
    brandId,
    modelId,
    varientId,
    oilTypeValue,
    ownerShipStatusValue,
    sort,
    dateBySort,
    branchId,
  },
})

export const getExcelDownloadVehicleSuccess = excelDownloadVehicle => ({
  type: GET_EXCEL_DOWNLOAD_VEHICLE_SUCCESS,
  payload: excelDownloadVehicle,
})

export const getExcelDownloadVehicleFail = error => ({
  type: GET_EXCEL_DOWNLOAD_VEHICLE_FAIL,
  payload: error,
})

export const getExcelDownloadLead = (
  page,
  sort,
  totalItemLimit,
  searchText,
  vehicleId,
  typeValue,
  clientId,
  medium,
  sortByDate,
  branchId
) => ({
  type: GET_EXCEL_DOWNLOAD_LEAD,
  payload: {
    page,
    sort,
    totalItemLimit,
    searchText,
    vehicleId,
    typeValue,
    clientId,
    medium,
    sortByDate,
    branchId,
  },
})

export const getExcelDownloadLeadSuccess = excelDownloadLead => ({
  type: GET_EXCEL_DOWNLOAD_LEAD_SUCCESS,
  payload: excelDownloadLead,
})

export const getExcelDownloadLeadFail = error => ({
  type: GET_EXCEL_DOWNLOAD_LEAD_FAIL,
  payload: error,
})

export const getExcelDownloadInvestmentLead = (
  sort,
  searchText,
  typeValue,
  medium,
  leadCondition,
  singleDate,
  sortByDate
) => ({
  type: GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD,
  payload: {
    sort,
    searchText,
    typeValue,
    medium,
    leadCondition,
    singleDate,
    sortByDate,
  },
})

export const getExcelDownloadInvestmentLeadSuccess = excelDownloadInvestmentLead => ({
  type: GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_SUCCESS,
  payload: excelDownloadInvestmentLead,
})

export const getExcelDownloadInvestmentLeadFail = error => ({
  type: GET_EXCEL_DOWNLOAD_INVESTMENT_LEAD_FAIL,
  payload: error,
})

export const getExcelDownloadInspectionDocument = (
  page,
  limit,
  searchText,
  StaffId,
  sortByDate
) => ({
  type: GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT,
  payload: {
    page,
    limit,
    searchText,
    StaffId,
    sortByDate,
  },
})

export const getExcelDownloadInspectionDocumentSuccess = excelDownloadLead => ({
  type: GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_SUCCESS,
  payload: excelDownloadLead,
})

export const getExcelDownloadInspectionDocumentFail = error => ({
  type: GET_EXCEL_DOWNLOAD_INSPECTION_DOCUMENT_FAIL,
  payload: error,
})

export const getExcelDownloadChallan = (
  page,
  limit,
  searchText,
  sort,
  sortByDate
) => ({
  type: GET_EXCEL_DOWNLOAD_CHALLAN,
  payload: {
    page,
    limit,
    searchText,
    sort,
    sortByDate,
  },
})

export const getExcelDownloadChallanSuccess = excelDownloadChallan => ({
  type: GET_EXCEL_DOWNLOAD_CHALLAN_SUCCESS,
  payload: excelDownloadChallan,
})

export const getExcelDownloadChallanFail = error => ({
  type: GET_EXCEL_DOWNLOAD_CHALLAN_FAIL,
  payload: error,
})

export const getExcelDownloadInspectionBooking = (
  page,
  sort,
  limit,
  searchText,
  sortByDate
) => ({
  type: GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING,
  payload: {
    page,
    sort,
    limit,
    searchText,
    sortByDate,
  },
})

export const getExcelDownloadInspectionBookingSuccess =
  excelDownloadBooking => ({
    type: GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_SUCCESS,
    payload: excelDownloadBooking,
  })

export const getExcelDownloadInspectionBookingFail = error => ({
  type: GET_EXCEL_DOWNLOAD_INSPECTION_BOOKING_FAIL,
  payload: error,
})
